/**
* 基础菜单 商品管理
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>人员列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
            <el-form-item label="人员姓名:" prop="name">
                <el-input maxlength="10"  clearable v-model="formInline.name"
                    placeholder="输入人员姓名"></el-input>
            </el-form-item>


            <el-form-item label="人员手机号：" prop="phone">
                <el-input maxlength="11" type="number" clearable v-model="formInline.phone"
                    placeholder="输入接收者手机"></el-input>
            </el-form-item>

            
            <el-form-item prop="status" label="状态:">
                <el-select v-model="formInline.status" placeholder="不限">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="有效" value="1"></el-option>
                    <el-option label="无效" value="2"></el-option>
                </el-select>
            </el-form-item>


            <!-- <el-form-item prop="operatorUserId" label="操作人员:">
                <el-select clearable v-model="formInline.operatorUserId" placeholder="请选择">
                    <el-option v-for="item in SelectList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
                <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
            </el-form-item>
            <el-form-item>
            </el-form-item>
            <div style=" float: right; margin-right: 50px; margin-bottom: 0px; " v-if="roleId.roleId==1||roleId.roleId==2">
                <el-button type="success" icon="el-icon-plus" @click="addCogilg">添加人员</el-button>
            </div>
        </el-form>

        <!--列表-->
        <el-table id="educe-table" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"
            @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
            style="width: 100%; font-size: 18px;">

            </el-table-column>
            <el-table-column align="center" prop="name" label="姓名" width="100">
            </el-table-column>

            <el-table-column align="center" prop="headIcon" label="人员照片" width="130">
                <template slot-scope="scope">
                    <el-image style="width: 100px; height: 100px;"
                        :src="scope.row.headIcon ? scope.row.headIcon : 'https://test-cos.ynhlminiapp.com/accountDefaultHeadIcon.png'"
                        :preview-src-list="[scope.row.headIcon ? scope.row.headIcon : 'https://test-cos.ynhlminiapp.com/accountDefaultHeadIcon.png']" />
                </template>
            </el-table-column>
            <el-table-column align="center" prop="roleName" label="角色名称" width="200">
            </el-table-column>
           

            <el-table-column v-if="roleId.roleId==1" align="center" prop="userName" label="账号" width="200">
            </el-table-column>
            <el-table-column v-if="roleId.roleId==1" align="center" prop="password" label="密码" width="200">
            </el-table-column>
            
            <el-table-column align="center" prop="phone" label="手机号" width="150">
                
                <template slot-scope="scope">
          <div>{{ scope.row.phone|mobileStr}}</div>
        </template>
            </el-table-column>
            <el-table-column prop="closeTime" align="center" label="修改时间">
                <template slot-scope="scope">
                    <div>{{ scope.row.updateTime | timestampToTime }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="status" align="center" label="人员状态" v-if="roleId.roleId==1||roleId.roleId==2">
                <template slot-scope="scope">
                    
                    <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'" effect="dark">{{
                scope.row.status == 1 ? '正常' : "锁定" }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="closeTime" align="center" fixed="right" label="操作" width="220" >
                <template slot-scope="scope">
                    <el-button type="primary"  v-if="roleId.roleId==1||roleId.roleId==2&&roleId.roleId<=scope.row.roleId" icon="el-icon-edit" @click="onClick(scope.row, 1)">编辑</el-button>
                    <el-button type="primary" v-if="roleId.id==scope.row.id&&roleId.roleId!=2&&roleId.roleId!=1" icon="el-icon-edit" @click="onClick(scope.row, 1)">编辑</el-button>
                    <el-button type="danger" v-if="roleId.roleId==1" icon="el-icon-delete" @click="onClick(scope.row, 2)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
            @size-change="handleSizeChange" @callFather="callFather"></Pagination>
        <el-dialog :close-on-click-modal="false" title="人员信息" width="30%" :visible.sync="dialogFormVisible" @close="hienVisible">
            <el-form :model="editForm"  :rules="rules" ref="editForm">
                <el-form-item label="姓名" prop="name" :label-width="formLabelWidth">
                    <el-input v-model="editForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone" :label-width="formLabelWidth">
                    <el-input v-model="editForm.phone" oninput="if(value.length > 11) value=value.slice(0, 11)"
                        type="number" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="userName" :label-width="formLabelWidth">
                    <el-input v-model="editForm.userName" type="number" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录密码" prop="password" :label-width="formLabelWidth">
                    <el-input v-model="editForm.password" autocomplete="off"></el-input>
                </el-form-item>
             
                <el-form-item label="角色" prop="roleId" :label-width="formLabelWidth">
                    <el-select v-model="editForm.roleId" placeholder="请选择角色权限">
                        <el-option v-for="item in Formlist" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="isindex==2&&roleId.roleId==1||roleId.roleId==2" label="状态" prop="status" :label-width="formLabelWidth">
                    <el-radio v-model="editForm.status" label="1">正常</el-radio>
          <el-radio v-model="editForm.status" label="2">锁定</el-radio>
                </el-form-item>


                <el-form-item label="图片" prop="path" :label-width="formLabelWidth">
                    <el-upload :limit='1' :class="{ disabled: uploadDisabled }" :action=ssoServerimg
                        list-type="picture-card" tokenId:this.adder :before-upload="beforeUpload"
                        :on-success="handleAvatarSuccess"   :file-list="fileList" :on-remove="handleRemove">

                        <i class="el-icon-plus"></i>
                    </el-upload>


                </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="hienVisible">取 消</el-button>
                <el-button type="primary" @click="onFormVisible('editForm')">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import Vue from 'vue'
import { userList, userDelete, roleList, userAdd,userEdit } from '../../api/userMG'
import Axios from 'axios'
import {mobileStr}from "../../utils/util"
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            dialogVisible: false,
            value: "",
            options123: [],
            ssoServer: "",
            fileList:[],
            ssoServerimg: "",
            formLabelWidth: '120px',
            dialogFormVisible: false,
            options1234123: [],
            isindex:"",
            uploadDisabled: false,
            aData: new Date(),

            adder: "",
            recommendform: {
                index: "",
                id: ""
            },
            roleId:"",
            nshow: true, //switch开启
            fshow: false, //switch关闭
            importList: [],
            SelectList: '',
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            title: '添加',

            editForm: {
                name: '',
                headIcon: "",
                password: "",
                phone: "",
                status:"",
                roleId: "",
                userName: ''

            },

            // rules表单验证
            rules: {

                userName: [
                    { required: true, message: '账号不能为空', trigger: 'blur' }
                ],
                roleId: [
                    { required: true, message: '角色不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '登录密码不能为空', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '手机号码不能为空', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
            },
            formInline: {
                nickName: "",
                phone: "",
              
                status: '',
                type: "",
               
                current: 1,
                size: 20,
            },
            Formlist: [],
            userparm: [], //搜索权限
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            }
        }
    },

    // 注册组件
    components: {
        Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
        this.roleId=JSON.parse(localStorage.getItem('userlist'))
        this.ssoServerimg = Vue.prototype.GLOBAL.ssoServerimg
        this.ssoServer = Vue.prototype.GLOBAL.ssoServer
        this.value = (new Date()).getTime();
        let tokenId = localStorage.getItem('tokenId');
        this.adder = tokenId
    },
    mounted() {
        this.formLIst()

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        onFormVisible(editForm) {
            this.$refs[editForm].validate((valid) => {
          if (valid) {
            if(this.fileList.length!=0){
               
                if(this.fileList[0].url){
                    this.editForm.headIcon=this.fileList[0].url
                }else{
                    this.editForm.headIcon=this.fileList
                }
               
                  
                 }else{
                    console.log('1121221212');
                    this.editForm.headIcon=''
                  
                 }
            if(this.isindex==1){
                // 添加
            userAdd(this.editForm).then(res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '添加成功'
                    })
                    this.formLIst()
                    this.dialogFormVisible = false

                }
            })
           
            }else{
                userEdit(this.editForm).then(res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                    this.formLIst()
                    this.dialogFormVisible = false

                }
            })
        
                //编辑

            }
          
          } else {
            console.log('error submit!!');
          }
        });
            

        },
        handleRemove(file, fileList) {
            this.fileList = []
            this.uploadDisabled = false;
        },
        hienVisible(){
   


   this.dialogFormVisible=false
   this.formLIst()
        },




        beforeUpload(file) {
            const _that = this
            const isJpgOrPng =
                file.type === "image/jpeg" || file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 6;
            if (!isJpgOrPng) {
                this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
                return false;
            }
            return new Promise((resolve) => {
                // 小于2M 不压缩
                if (isLt2M) {
                    resolve(file)
                }
                // 压缩到400KB,这里的400就是要压缩的大小,可自定义
                imageConversion.compressAccurately(file, 400).then((res) => {
                    console.log(res);
                    resolve(res);
                });

            });
        },

        handleAvatarSuccess(res, file) {
            this.fileList = res.data
        
            if (this.fileList) {
                this.uploadDisabled = true
            }
        },
        deleteUser(e) {
            this.$router.push({
                path: "/Eventmanagement/activitiesDetail",
                query: { //query是个配置项
                    id: e
                }
            })

        },
        // 推荐
        // getCurrentTime() {
        //     //获取当前时间并打印
        //     var _this = this;
        // let yy = new Date().getFullYear();
        // let mm = new Date().getMonth()+1;
        // let dd = new Date().getDate();
        // let hh = new Date().getHours();
        // let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
        // let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
        // _this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
        // console.log(_this.gettime)  
        // },
        recommend(i, f) {
            if (i == -1) {
                this.recommendform.id = f.id
                this.recommendform.index = 0

                this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {


                    Axios({
                        method: 'post',
                        url: this.ssoServer + '/api/activity/updateIndex',

                        headers: {
                            tokenId: this.adder
                        },
                        data: this.recommendform
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '取消成功'
                            })
                            this.formLIst()
                        }
                    })

                }).catch(() => {

                });
                return

            } else {
                this.editFormVisible = true

            }
            this.recommendform.id = f.id


            this.recommendform.index = ''

        },




        addCogilg() {

            this.isindex='1'
            roleList().then(res => {
                if(this.roleId.roleId==2){
                    this.Formlist = res.data.list.slice(2)
                }else if(this.roleId.roleId>=3){
                    this.Formlist = res.data.list.slice(2)
                }else{
                    this.Formlist = res.data.list
                }
        })
   this.editForm.name=''
   this.editForm.headIcon=''
   this.editForm.password=''
   this.editForm.phone=''
   this.editForm.status=''
   this.editForm.roleId=''
   this.editForm.userName=''

        this.fileList=[]
        this.uploadDisabled=false
     
        this.dialogFormVisible = true
        },
        selectall(val) {
            // console.log(val);

            let data = []
            // this.importList=''
            val.forEach((item) => {
                data.push(item.id)
                this.importList = data
                console.log(this.importList);

            })

            // this.importList
            // console.log(val);
        },


        getAddress() {

            Axios({
                method: 'get',
                url: this.ssoServer + '/api/common/getAddressList1',

                headers: {
                    tokenId: this.adder
                }
            }).then(res => {
                if (res.data.code == 999) {
                    setTimeout(() => {
                        localStorage.removeItem('tokenId')

                        this.$store.commit('logout', 'false')
                        this.$router.push({ path: '/login' })
                        this.$message({
                            type: 'success',
                            message: '登录过期,请重新登录'
                        })
                    }, 1000)
                }
                // console.log("getAddressList", res.data.data);
                this.options123 = res.data.data

            })
        },


        change1(e) {
            console.log("change1", e);
            if (e.length === 1) {
                this.$message({
                    type: 'error',
                    message: '请选择详细地址'
                })
            }
            if (e.length === 2) {
                this.formInline.registerAddress = e[1];
            }
        },

        selectalls(rows) {

            if (rows) {
                let data = []
                rows.forEach((item) => {
                    data.push(item.id)
                    this.importList = data
                    console.log(this.importList);

                })
                rows.forEach(row => {

                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                console.log('1212112');
                this.importList = []

                this.$refs.multipleTable.clearSelection();//清除全选
            }


        },

        onChange(e) {

            this.formInline.activityAddressCode = e[1]
            // console.log( this.formInline.registerAddress);


        },
        selectall(val) {

            let data = []
            val.forEach((item) => {
                data.push(item.id)
                this.importList = data
                console.log(this.importList);

            })

            // this.importList
            console.log(val);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 导出数据
        imporList() {
            if (this.importList.length == 0) {

                this.$message({
                    type: 'warning',
                    message: '请选择要导出的数据'
                })
                return

            } else {
                Axios({
                    method: 'post',

                    url: this.ssoServer + '/api/platform-account/exportExcel',
                    headers: {
                        tokenId: this.adder
                    },
                    data: {
                        accountIds: this.importList,
                        searchType: 1
                    },
                    responseType: 'blob'
                }).then(res => {
                    const link = document.createElement('a') // 创建a标签
                    const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
                    link.href = window.URL.createObjectURL(blob)
                    const filename = res.headers['content-disposition'].split('filename=')[1]
                    link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
                    link.click()
                    window.URL.revokeObjectURL(link.href)
                })


            }




        },
        select(selection, row) {

            let data = []
            // this.importList=''
            selection.forEach((item) => {
                data.push(item.id)
                this.importList = data
                console.log(this.importList);

            })

            // console.log(this.importList);
            // console.log(selection);
        },
        resetForm(formInline) {
            //  this.formInline =''
            this.$refs[formInline].resetFields();
        },

        onClick(row, idnex) {
            if (idnex == 2) {
                this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    userDelete({
                        id: row.id
                    }).then(res => {
                        if (res.code == 0) {
                            this.formLIst()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
                //删除
            } else {
                roleList().then(res => {
                if(this.roleId.roleId==2){
                    this.Formlist = res.data.list.slice(2)
                }else if(this.roleId.roleId>=3){
                    this.Formlist = res.data.list.slice(2)
                }else{
                    this.Formlist = res.data.list
                }
           
        })
           this.isindex='2'
              this.editForm=row
            
              this.editForm.status = String(row.status)
              if(row.headIcon){
        this.fileList=[];
        this.fileList.push({
          'url': row.headIcon  
        })
        if(this.fileList){
            this.uploadDisabled=true
        }
              }else{
                this.uploadDisabled=false
                this.fileList=[];
              }
            

    this.dialogFormVisible=true
                // 编辑

            }

        },
        formLIst() {

            userList(this.formInline).then(res => {
                if (res.code == 0) {
                    this.listData = res.data.list
                    this.pageparm.total = res.data.total
                }
            })
        },
        formatData(row, column, cellValue, index) {

            //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
            //最终返回 s 就可以了
            var s = new Date(cellValue).toLocaleString();
            return s;
        },
        handleSizeChange(e) {
            // reru console.log(e.pageSize);
            this.formInline.size = e.pageSize
            this.formInline.current = e.currentPage

            this.formLIst()
            // console.log(e);
        },
        // 分页插件事件
        callFather(parm) {
            console.log(parm);

            this.formInline.size = parm.pageSize
            this.formInline.current = parm.currentPage
            this.formLIst()
        },
        // 搜索事件
        search() {
            this.formInline.current = 1
            this.value = (new Date()).getTime();

            this.formLIst()
        },
   
        // 编辑、增加页面保存方法
        submitForm(editData) {
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if (this.recommendform.index == '') {
                        return this.$message({
                            type: 'warning',
                            message: '推荐排序不能为空'
                        })
                    }
                    Axios({
                        method: 'post',
                        url: this.ssoServer + '/api/activity/updateIndex',

                        headers: {
                            tokenId: this.adder
                        },
                        data: this.recommendform
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '推荐成功'
                            })
                            this.editFormVisible = false
                            this.formLIst()

                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.data.message
                            })
                            return

                        }


                    })
                }
            })
        },
        // async logins() {
        //     // 网络请求
        //     let data = await login('1111111');
        //     // let token = data.token;
        //     // 本地  vuex
        //     // this.$store.commit('LOGIN_IN',token);
        //     this.$router.replace("/")
        // },

        // 删除公司

        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible = false
        }
    }
}
</script>

<style>
.user-search {
    margin-top: 20px;
}

.disabled .el-upload--picture-card {
    display: none !important;
}

.userRole {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/adminiStration/AddRole.vue